import { Grid, SystemProps } from "@chakra-ui/react";
import React from "react";
import { OrderFilterSetting } from "../../../../types/order/orderQuery";
import { MainTransactionsTableHeader } from "./MainTransactionsTableHeader";
import { MainTransactionTableRows } from "./MainTransactionTableRows";

export function MainTransactionsTable({
  onClickOrder,
  filters,
  top,
  totalTransactionCount,
}: {
  onClickOrder: (transactionId: string) => void;
  filters: OrderFilterSetting;
  top: SystemProps["top"];
  totalTransactionCount?: number;
}) {
  const showRunningBalance = filters.asset.length === 1;

  const gridColumns = showRunningBalance ? 9 : 8;

  return (
    <>
      <Grid
        px={{
          base: 0,
          "2xl": 8,
        }}
        w="full"
        templateColumns={getTransactionTableColumns(showRunningBalance)}
        rowGap={2}
        columnGap={0}
      >
        <MainTransactionsTableHeader top={top} filters={filters} />
        <MainTransactionTableRows
          onClickOrder={onClickOrder}
          filters={filters}
          gridColumns={gridColumns}
          totalTransactionCount={totalTransactionCount}
        />
      </Grid>
    </>
  );
}

const contentColumn = "max-content";
const fillColumn = "minmax(min-content, 1fr)";
const dataSourceColumn = "fit-content(10em)";

function getTransactionTableColumns(showRunningBalance: boolean) {
  return [
    "max-content", // checkbox
    contentColumn, // date
    dataSourceColumn, // data source
    contentColumn, // type
    contentColumn, // out
    contentColumn, // in
    showRunningBalance ? contentColumn : undefined,
    contentColumn, // outcome
    fillColumn, // suggestion
    // we grow any free whitespace off to the right of the suggestion column, to keep the rest of the content compact
  ]
    .filter(Boolean)
    .join(" ");
}
